import { Link } from 'react-router';
import { SearchX } from 'lucide-react';
import { removeKey } from '../lib/storage';
import { Button, EmptyState } from '../ui/kit';

export function TenantNotFound() {
  return (
    <div className="mx-auto flex min-h-dvh max-w-md flex-col justify-center px-6">
      <EmptyState
        icon={<SearchX className="size-7" />}
        title="İşletme bulunamadı"
        text="Bağlantı eski ya da hatalı olabilir. İşletmedeki karekodu yeniden okutmayı dene."
        action={
          <Link to="/" onClick={() => removeKey(null, 'lastTenant')}>
            <Button variant="secondary">Başka işletme seç</Button>
          </Link>
        }
      />
    </div>
  );
}
